var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9993 1.99996H1.99935V9.99996H13.9993V1.99996ZM1.99935 0.666626H0.666016V1.99996V9.99996V11.3333H1.99935H13.9993H15.3327V9.99996V1.99996V0.666626H13.9993H1.99935ZM11.269 4.68989L11.61 4.91727L13.61 6.2506L13.0553 7.08265L11.3964 5.97669L8.68623 8.68685L8.40498 8.9681L8.06768 8.75729L5.71843 7.28901L2.9982 9.707L2.33383 8.95959L5.33383 6.29292L5.6136 6.04424L5.93101 6.24263L8.26038 7.69848L10.9791 4.97974L11.269 4.68989ZM4.66602 5.33329C5.40239 5.33329 5.99935 4.73634 5.99935 3.99996C5.99935 3.26358 5.40239 2.66663 4.66602 2.66663C3.92964 2.66663 3.33268 3.26358 3.33268 3.99996C3.33268 4.73634 3.92964 5.33329 4.66602 5.33329Z",
    fill: "#4D4E65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/Photo.4b3e4782d614ab550a3eabc2627ea748.svg";
export { ForwardRef as ReactComponent };